export default "__VITE_ASSET__0pQDYXxw__"